import { Redirect } from 'expo-router';

/**
 * Legacy onboarding step. Location is no longer requested at signup — the
 * map's locate FAB is the only entry point. Bounce inbound traffic to the
 * map so old deep links don't 404; file can be deleted later.
 */
export default function LocationCheckRedirect() {
  return <Redirect href="/(tabs)" />;
}
